function empty({ next, nextMiddleware }) {
  return nextMiddleware();
}

export default empty;
